import i18next from 'i18next';

import { en } from './english';
import { es } from './spanish';
import { pl } from './polish';
import { fr } from './french';
import { mk } from './macedonian';
import { se } from './swedish';
import { ar } from './arabic';
import { it } from './italian';
import { de } from './german';
import { nl } from './dutch';
import { dk } from './danish';
import { pt } from './portuguese';

i18next.init({
    interpolation: {
        escapeValue: false,
    },
    lng: 'en',
    resources: {
        en: {
            translation: {
                ...en,
            },
        },
        es: {
            translation: {
                ...es,
            },
        },
        pl: {
            translation: {
                ...pl,
            },
        },
        fr: {
            translation: {
                ...fr,
            },
        },
        mk: {
            translation: {
                ...mk,
            },
        },
        se: {
            translation: {
                ...se,
            },
        },
        ar: {
            translation: {
                ...ar,
            },
        },
        it: {
            translation: {
                ...it,
            },
        },
        de: {
            translation: {
                ...de,
            },
        },
        nl: {
            translation: {
                ...nl,
            },
        },
        dk: {
            translation: {
                ...dk,
            },
        },
        pt: {
            translation: {
                ...pt,
            },
        },
    },
});

export default i18next;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js